import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-accent-100/30 text-accent-700 text-xs font-label font-medium rounded-full mb-4">
            Trust & Safety
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Superbuy Spreadsheet Safety Guide
          </h2>
          <p className="text-foreground-500 text-sm max-w-xl mx-auto">
            Before using any Superbuy spreadsheet resource, keep these guidelines in mind for a safer shopping experience
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { icon: 'ri-shield-check-line', title: 'Verify Product Information', desc: 'Cross-reference product details, images, and descriptions with multiple sources before making any purchase decisions.' },
            { icon: 'ri-links-line', title: 'Check External Links', desc: 'Avoid clicking suspicious links. Only use verified product URLs from trusted spreadsheet sources and double-check destinations.' },
            { icon: 'ri-lock-line', title: 'Protect Personal Data', desc: 'Never share sensitive personal or payment information through unverified channels or spreadsheet comment sections.' },
            { icon: 'ri-user-star-line', title: 'Review Seller Reputation', desc: 'Check seller ratings, transaction history, and community feedback before committing to any purchase.' },
            { icon: 'ri-refresh-line', title: 'Data May Change', desc: 'Spreadsheet information including pricing, availability, and product listings may change. Always verify current status before buying.' },
            { icon: 'ri-brain-line', title: 'Use Common Sense', desc: 'If a deal seems too good to be true, trust your instincts. Research thoroughly and shop responsibly at all times.' },
          ].map((item) => (
            <div key={item.title} className="bg-background-50 rounded-xl p-6 md:p-8">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/50 text-accent-600 mb-4">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Process Steps */}
        <div className="mt-16">
          <h3 className="font-heading text-2xl font-bold text-foreground-950 text-center mb-10">
            How Superbuy Spreadsheet Works
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { step: '01', icon: 'ri-folder-open-line', title: 'Browse Categories', desc: 'Explore organized spreadsheet categories including shoes, clothing, accessories, and more.' },
              { step: '02', icon: 'ri-scales-line', title: 'Compare Products', desc: 'View side-by-side product details, images, pricing, and QC reference photos in one place.' },
              { step: '03', icon: 'ri-search-eye-line', title: 'Research QC Details', desc: 'Review quality control photos, sizing information, and community feedback for informed decisions.' },
              { step: '04', icon: 'ri-shopping-cart-2-line', title: 'Shop With Confidence', desc: 'Click through to verified product listings and continue your shopping journey on the main store.' },
            ].map((item) => (
              <div key={item.step} className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-primary-50 flex items-center justify-center">
                  <i className={`${item.icon} text-2xl text-primary-500`}></i>
                </div>
                <span className="font-heading text-3xl font-bold text-background-300 block mb-2">
                  {item.step}
                </span>
                <h4 className="font-label font-semibold text-sm text-foreground-800 mb-2">
                  {item.title}
                </h4>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Article CTA */}
        <div className="mt-16 text-center">
          <Link
            to="/articles/superbuy-spreadsheet-guide"
            className="inline-flex items-center gap-2 px-8 py-4 bg-primary-500 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Read the Complete Superbuy Spreadsheet Guide
            <i className="ri-arrow-right-line text-base"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}